import React from 'react';
import { Card, CardContent, Typography, Box, Grid, Divider, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import configSiteUrls from '../../configs/configSiteUrls';
import { PublicacaoOficialList } from '../publicacaoOficial/types/PublicacaoOficial';

interface PublicacaoOficialCardProps {
  publicacoes: PublicacaoOficialList[];
  isFetching?: boolean;
}

export default function PublicacaoOficialHomeCardForm({ publicacoes, isFetching }: PublicacaoOficialCardProps) {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate(`${configSiteUrls.SITE_PUBLICACAO_OFICIAL_PUBLIC_LIST}`);
  };

  if (isFetching) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="textSecondary">Carregando últimas publições oficiais...</Typography>
      </Box>
    );
  }

  if (!publicacoes || publicacoes.length === 0) {
    return  <Typography variant="body2" color="textSecondary">Erro: Publicações não carregadas!</Typography>;
  }

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography
          color="primary"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '20px', sm: '22px', md: '24px' },
            lineHeight: { xs: '26px', sm: '28px', md: '30px' },
            mt: 1
          }}
        >
          Publicações
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {publicacoes.map(publicacaoOficial => (
          <Grid
            item
            key={publicacaoOficial.id}
            xs={12} // Mobile: ocupa toda largura
            sm={6} // Tablet: ocupa metade
            md={4} // Desktop: 3 cards por linha
          >
            <Card
              sx={{
                width: '100%',
                height: '200px', // altura fixa para manter consistência
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}
            >
              <a href="#" onClick={e => handleClick(e)} style={{ textDecoration: 'none', color: 'inherit', height: '100%' }}>
                <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                  {/* Linha 1: Exercício e tipo */}
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="secondary" sx={{ fontWeight: 500 }}>
                      Exercício: {publicacaoOficial?.exercicio || 'N/A'} - {publicacaoOficial?.tipo.nome}
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Divider sx={{ borderColor: '#EBEBEB' }} />
                  </Box>
                  {/* Linha 2: Observação */}
                  <Box sx={{ mt: 1, flexGrow: 1 }}>
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{
                        fontWeight: 400,
                        fontSize: { xs: '13px', sm: '14px', md: '15px' },
                        lineHeight: { xs: '18px', sm: '20px', md: '22px' },
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 4, // limita a 4 linhas
                        WebkitBoxOrient: 'vertical',
                        wordBreak: 'break-word'
                      }}
                    >
                      {publicacaoOficial.observacao}
                    </Typography>
                  </Box>
                </CardContent>
              </a>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
